export const GET_ALL_ANALYSIS_RESPONSE = {
  Analyses: 'Analyses',
  TokenError: 'TokenError',
  Unauthorized: 'Unauthorized',
};
